<template>
    <div class="tcPlayer fullSpace">
        <video class="videoControl" :id="'videoControl' + id" :style="videoStyle"></video>
    </div>
</template>

<script>

import appConfig from "@/appConfig";

import timerManager from "@comp/platformApi/timerManager";

// util
import consoleHelper from '@util/consoleHelper';
import consoleApi from "@comp/platformApi/consoleApi";

export default {
    name: "tcPlayer",
    props : {
        id : {
            type : String,
            default : '1'
        },
        fileID : {
            type : String,
            default : ''
        },
        image :{
            type : String,
            default :''
        },
        controls : {
            type : Boolean,
            default : true
        },
        controlBar : {
            type : Object
        },
        plugins : {
            type : Object
        },
        videoStyle : String
    },
    data() {
        return {
            tcPlayerControl : null,

            playerOptions : {
                fileID: '', // 请传入需要播放的视频filID 必须
                appID: '', // 请传入点播账号的appID 必须
                controls : this.controls,
                controlBar : this.controlBar,
                plugins: {
                    ContinuePlay: {
                        auto: true, // 是否在播放时自动续播
                        text: '上次播放至 ', // 提示文案
                        btnText: '恢复播放' // 按钮文案
                    }
                },
                posterImage :true,
                poster : '',
                autoplay:true
            }
        }
    },
    methods : {
        getPlayerControl() {
            return this.tcPlayerControl;
        },
        play() {
            this.tcPlayerControl.play();
        },
        pause() {
            this.tcPlayerControl.pause();
        },
        currentTime(time = null) {
            if (time)
            {
                this.tcPlayerControl.currentTime(time);
            }
            else
            {
                return this.tcPlayerControl.currentTime();
            }
        },
        duration() {
            this.tcPlayerControl.duration();
        },
        volume(percent) {
            if (percent)
            {
                this.tcPlayerControl.volume(percent);
            }
            else {
                return this.tcPlayerControl.volume();
            }
        },
        poster(src = null) {
            this.tcPlayerControl.poster(src);
        },
        width(width) {

            if (width)
            {
                this.tcPlayerControl.width(width);
            }
            else
            {
                return this.tcPlayerControl.width();
            }
        },
        height(height) {
            if (height)
            {
                this.tcPlayerControl.height(height);
            }
            else
            {
                return this.tcPlayerControl.height();
            }
        },

        loadVideoByID(fileId) {

            this.tcPlayerControl.loadVideoByID({
                fileID : fileId, // 请传入需要播放的视频 fileID（必须）
                appID: this.playerOptions.appID, // 请传入点播账号的 appID（必须）
                // psign:'' // 参考 Key 防盗链说明
            });
        }
    },
    mounted() {

        const me = this;

        this.playerOptions.appID   = appConfig.qcloud.video.appId;

        this.tcPlayerControl = new TCPlayer('videoControl' + this.id, this.playerOptions);

        this.tcPlayerControl.on('play', () => {
            consoleHelper.log('[tcPlayer] player play event.')
            // detail.g.listenStartTime = new Date().getTime();
            me.$emit('play');
        });
        this.tcPlayerControl.on('pause', () => {
            consoleHelper.log('[tcPlayer] player pause event.')
            // detail.action.submitListenRecord();
            me.$emit('pause');
        });

        // 结束也会触发暂停事件
        this.tcPlayerControl.on('ended', () => {
            consoleHelper.log('[tcPlayer] player ended event.')
            // detail.g.liID = parseInt(detail.g.liID) + 1
            // var _this = $('#' + detail.g.liID)
            // var eid = _this.attr('eid')
            // detail.action.getSegmentListDetail.req(eid, _this);

            //
            // detail.action.submitListenRecord();
            me.$emit('ended');
        });

        this.tcPlayerControl.on('timeupdate', (event) => {
            consoleHelper.logDebug('[tcPlayer] player timeupdate event.')
            me.$emit('timeupdate', event);
        });

        this.tcPlayerControl.on('error', function (event) {
            consoleHelper.log(event);
            me.$emit('error', event);
        });

        // add some delay for tc player init
        timerManager.setTimeout(() => {
            me.$emit('ready', me.tcPlayerControl);
        }, 2 * 1000);

    },
    watch: {
        fileID: function(newVal,oldVal){
            consoleApi.log('[tcPlayer] fileID changed. load new video.');
            this.playerOptions.fileID   = newVal;
            this.tcPlayerControl.loadVideoByID(this.playerOptions);
        },
        image : function (newVal,oldVal) {
            consoleApi.log('[tcPlayer] image changed. update new image.');
            this.tcPlayerControl.poster(this.image);
        }
    },
    beforeDestroy() {
        this.tcPlayerControl.dispose();
        this.tcPlayerControl = null;
    }
}
</script>

<style lang="scss" scoped>
.videoControl {
    /* 4:3 */
    width: 100vw;
    height: 75vw;

    background: black;
}
</style>
